var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ImgUpload',_vm._b({ref:"imgs",attrs:{"file":_vm.tbForm[_vm.key],"isSingle":true},on:{"upload-success":function (url) { return _vm.onChange(url); },"del":function () { return _vm.onChange(''); }}},'ImgUpload',_vm.extraAttr,false))}
var staticRenderFns = []

export { render, staticRenderFns }